import { render } from "./VerifyOtpLDAPPopup.vue?vue&type=template&id=37d589ec&scoped=true&ts=true"
import script from "./VerifyOtpLDAPPopup.vue?vue&type=script&lang=ts"
export * from "./VerifyOtpLDAPPopup.vue?vue&type=script&lang=ts"

import "./VerifyOtpLDAPPopup.vue?vue&type=style&index=0&id=37d589ec&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d589ec"]])

export default __exports__